import { createReducer } from "reduxsauce";
import _ from "lodash";
import ReducerRegister from "../../../ReducerRegister";
import BatchService from "../../../../services/screens/admin/unit/BatchService";
import { ActionTypes } from "../../../actionTypes/screens/admin/unit/SimpleBatchAddActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import * as Helper from "../../../../utils/Helper";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.unit.simplebatchadd;

var g_modifySeq = 1;

function toLocalUnitType(unitType, unitData) {
    if (unitType === 'PSSD2') {
        if (unitData.answerType === 4) {
            return 'PSSD2_AUDIO';
        }
    }
    return unitType;
}

function makeSubUnits(unit) {
    if (unit.unitType !== 'PSSO1') {
        return null;
    }

    let result = [];
    const data = JSON.parse(unit.data);
    for (let i = 0; i < data.practices.length; ++i) {
        const practice = data.practices[i];
        const subUnitId = Helper.generateUUID();
        const order = result.length + 1;
        const unitData = JSON.parse(practice.data);
        result.push({
            parentId: unit.id,
            id: subUnitId,
            ownerType: unit.ownerType,
            ownerId: unit.ownerId,
            resourceId: Helper.generateUUID(),
            unitType: toLocalUnitType(practice.unitType, unitData),
            duration: 0,
            data: unitData,
            order: order,
            isNew: false,
            modified: 0,
            changed: false,
            skipValidate: false,
        });
    }
    return result;
}

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            BatchService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (vo, data) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        vo,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    changeTitleAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.CHANGE_TITLE_ASYNC, vo });

            if (vo.sectionId) {
                BatchService.changeTitle(
                    vo,
                    response => {
                        dispatch(Actions.changeTitleSuccess(vo.title));
                    },
                    error => {
                        dispatch(Actions.changeTitleFailure(error));
                    }
                );
            } else {
                setTimeout(() => dispatch(Actions.changeTitleSuccess(vo.title)), 0);
            }
        };
    },

    changeTitleSuccess: (title) => ({
        type: ActionTypes.CHANGE_TITLE_SUCCESS,
        parentType: ActionTypes.CHANGE_TITLE_ASYNC,
        postReducer: changeTitleSuccessPostReducer,
        title
    }),

    changeTitleFailure: error => ({
        type: ActionTypes.CHANGE_TITLE_FAILURE,
        parentType: ActionTypes.CHANGE_TITLE_ASYNC,
        error
    }),

    saveUnitAsync: (vo, modifySeq) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_UNIT_ASYNC, vo });

            return new Promise((resolve, reject) => {
                BatchService.saveUnit(
                    vo,
                    response => {
                        dispatch(Actions.saveUnitSuccess(response, vo, modifySeq));
                        resolve();
                    },
                    error => {
                        dispatch(Actions.saveUnitFailure(error));
                        reject();
                    }
                );
            });
        };
    },

    saveUnitSuccess: (data, vo, modifySeq) => ({
        type: ActionTypes.SAVE_UNIT_SUCCESS,
        parentType: ActionTypes.SAVE_UNIT_ASYNC,
        postReducer: saveUnitSuccessPostReducer,
        data,
        vo,
        modifySeq
    }),

    saveUnitFailure: error => ({
        type: ActionTypes.SAVE_UNIT_FAILURE,
        parentType: ActionTypes.SAVE_UNIT_ASYNC,
        error
    }),

    saveUnitSilentAsync: (vo, modifySeq) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_UNIT_SILENT_ASYNC, vo });

            return new Promise((resolve, reject) => {
                BatchService.saveUnit(
                    vo,
                    response => {
                        dispatch(Actions.saveUnitSilentSuccess(response, vo, modifySeq));
                        resolve();
                    },
                    error => {
                        dispatch(Actions.saveUnitSilentFailure(error));
                        reject();
                    }
                );
            });
        };
    },

    saveUnitSilentSuccess: (data, vo, modifySeq) => ({
        type: ActionTypes.SAVE_UNIT_SILENT_SUCCESS,
        parentType: ActionTypes.SAVE_UNIT_SILENT_ASYNC,
        postReducer: saveUnitSuccessPostReducer,
        data,
        vo,
        modifySeq
    }),

    saveUnitSilentFailure: error => ({
        type: ActionTypes.SAVE_UNIT_SILENT_FAILURE,
        parentType: ActionTypes.SAVE_UNIT_SILENT_ASYNC,
        error
    }),

    deleteUnitAsync: id => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.DELETE_UNIT_ASYNC, id });

            const { unitDataList } = getState().screens[reducer.key];
            let [index, subIndex] = findUnitById(unitDataList, id);
            if (subIndex >= 0) {
                dispatch(Actions.deleteUnitSuccess(null, id));
            } else if (index >= 0) {
                if (unitDataList[index].isNew) {
                    dispatch(Actions.deleteUnitSuccess(null, id));
                } else {
                    BatchService.deleteUnit(
                        unitDataList[index].remoteId,
                        response => {
                            dispatch(Actions.deleteUnitSuccess(response, id));
                        },
                        error => {
                            dispatch(Actions.deleteUnitFailure(error));
                        }
                    );
                }
            }
        };
    },

    deleteUnitSuccess: (data, unitId) => ({
        type: ActionTypes.DELETE_UNIT_SUCCESS,
        parentType: ActionTypes.DELETE_UNIT_ASYNC,
        postReducer: deleteUnitReducer,
        data,
        unitId
    }),

    deleteUnitFailure: error => ({
        type: ActionTypes.DELETE_UNIT_FAILURE,
        parentType: ActionTypes.DELETE_UNIT_ASYNC,
        error
    }),

    reorderAsync: (unitId, sourceIndex) => {
        return (dispatch, getState) => {

            const { sectionId, unitDataList } = getState().screens[reducer.key];
            const [toIndex, subIndex] = findUnitById(unitDataList, unitId);
            const unit = unitDataList[toIndex];
            const remoteId = unit.remoteId;
            let order = unit.order;
            if (sourceIndex !== toIndex) {
                if (toIndex === 0) {
                    order = unitDataList[1].order / 2.0;
                } else if (toIndex === unitDataList.length - 1) {
                    order = unitDataList[toIndex - 1].order + 1.0;
                } else {
                    order = unitDataList[toIndex - 1].order + (unitDataList[toIndex + 1].order - unitDataList[toIndex - 1].order) / 2.0;
                }
            }

            dispatch({
                type: ActionTypes.REORDER_ASYNC,
                postReducer: reorderAsyncPostReducer,
                unitId,
                toIndex,
                order
            });

            if (sectionId && (!unit.isNew) && (sourceIndex !== toIndex)) {
                const vo = { sectionId, unitId: remoteId, order };
                BatchService.changeOrder(
                    vo,
                    response => {
                        dispatch(Actions.reorderSuccess(response));
                    },
                    error => {
                        dispatch(Actions.reorderFailure(error));
                    }
                );
            }
        };
    },

    reorderSuccess: (data) => ({
        type: ActionTypes.REORDER_SUCCESS,
        parentType: ActionTypes.REORDER_ASYNC,
        data
    }),

    reorderFailure: error => ({
        type: ActionTypes.REORDER_FAILURE,
        parentType: ActionTypes.REORDER_ASYNC,
        error
    }),

    batchAddUnitAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.BATCH_ADD_UNIT_ASYNC, vo });

            BatchService.batchAddUnit(
                vo,
                response => {
                    dispatch(Actions.batchAddUnitSuccess(response));
                },
                error => {
                    dispatch(Actions.batchAddUnitFailure(error));
                }
            );
        };
    },

    batchAddUnitSuccess: (data) => ({
        type: ActionTypes.BATCH_ADD_UNIT_SUCCESS,
        parentType: ActionTypes.BATCH_ADD_UNIT_ASYNC,
        data
    }),

    batchAddUnitFailure: error => ({
        type: ActionTypes.BATCH_ADD_UNIT_FAILURE,
        parentType: ActionTypes.BATCH_ADD_UNIT_ASYNC,
        error
    }),

    batchAddAndCreateUnitAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.BATCHADD_AND_CREATE_UNIT_ASYNC, vo });

            BatchService.batchAddUnit(
                vo,
                response => {
                    dispatch(Actions.batchAddAndCreateUnitSuccess(response));
                },
                error => {
                    dispatch(Actions.batchAddAndCreateUnitFailure(error, vo));
                }
            );
        };
    },

    batchAddAndCreateUnitSuccess: (data) => ({
        type: ActionTypes.BATCHADD_AND_CREATE_UNIT_SUCCESS,
        parentType: ActionTypes.BATCHADD_AND_CREATE_UNIT_ASYNC,
        postReducer: batchAddAndCreateUnitSuccessPostReducer,
        data
    }),

    batchAddAndCreateUnitFailure: error => ({
        type: ActionTypes.BATCHADD_AND_CREATE_UNIT_FAILURE,
        parentType: ActionTypes.BATCHADD_AND_CREATE_UNIT_ASYNC,
        error
    }),

    selectUnitType: unitType => ({
        type: ActionTypes.SELECT_UNIT_TYPE,
        unitType
    }),

    addUnit: (index, vo, cb) => ({
        type: ActionTypes.ADD_UNIT,
        index,
        vo,
        cb,
    }),

    showAddSubUnit: (unitId, show) => ({
        type: ActionTypes.SHOW_ADD_SUBUNIT,
        unitId,
        show,
    }),

    addSubUnit: (unitId, vo, cb) => ({
        type: ActionTypes.ADD_SUBUNIT,
        unitId,
        vo,
        cb,
    }),

    moveUnit: (unitId, toIndex) => ({
        type: ActionTypes.MOVE_UNIT,
        unitId,
        toIndex,
    }),

    updateUnit: (unitId, formData) => ({
        type: ActionTypes.UPDATE_UNIT,
        unitId,
        formData,
    }),

    editUnit: (unitId) => ({
        type: ActionTypes.EDIT_UNIT,
        unitId,
    }),

    cancelEdit: () => ({
        type: ActionTypes.CANCEL_EDIT,
    }),

    changeUnitType: (vo) => ({
        type: ActionTypes.CHANGE_UNIT_TYPE,
        vo,
    }),

    deleteUnit: (unitId) => ({
        type: ActionTypes.DELETE_UNIT,
        unitId,
    }),

    deleteAllUnits: () => ({
        type: ActionTypes.DELETE_ALL_UNITS,
    }),

    showErrorUnits: (units) => ({
        type: ActionTypes.SHOW_ERROR_UNITS,
        units,
    }),

    recreate: () => ({
        type: ActionTypes.RECREATE,
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    unitTypeList: null,
    unitDataList: [],
    sectionId: null,
    courseType: null,
    maxOrder: 0,
    editable: false,
    data: null,
    title: "",
    unitType: "",
    duration: null,
    editUnitId: null,
    showErrors: null,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { vo, data }) => {
    const { edit, defaultTitle, courseType } = vo;
    const { section, unitTypeList, maxOrder, editable } = data;
    const { title, units } = section || {};
    let unitDataList = [];
    let editUnitId = null;
    if (edit && units) {
        for (let i = 0; i < units.length; ++i) {
            let unit = units[i];
            let unitData = JSON.parse(unit.data);
            unit.unitType = toLocalUnitType(unit.unitType, unitData);
            let subunits = makeSubUnits(unit);
            let addsub = unit.addsub;
            unitDataList.push({...unit, remoteId: unit.id, data: unitData, subunits, addsub});
        }

        if (editable && units[0]) {
            editUnitId = units[0].id;
        }
    }
    return { ...state, title: (title || defaultTitle),
             sectionId: (section ? section.id : null),
             courseType: (section ? section.courseType : courseType ? parseInt(courseType) : null),
             maxOrder: maxOrder,
             unitTypeList: unitTypeList.filter(item => item.enabled === true || item.id === 'PSSO1'),
             unitDataList: unitDataList,
             editUnitId,
             editable};
};

const changeTitleSuccessPostReducer = (state, { title }) => {
    return { ...state, title: title };
};

const selectUnitTypeReducer = (state, { unitType }) => {
    return { ...state, unitType: unitType.id, duration: unitType.duration };
};

const batchAddAndCreateUnitSuccessPostReducer = (state) => {
    return { ...state, data: null, unitType: "", duration: null };
};

const recreateReducer = (state) => {
    return { ...state, data: null, unitType: "", duration: null };
};

const addUnitReducer = (state, { index, vo, cb }) => {
    const { unitType, ownerType, ownerId, data, changed, skipValidate } = vo;
    let unitDataList = _.clone(state.unitDataList);
    if (index < 0) {
        index = unitDataList.length;
    }

    let order = state.maxOrder + 1;
    for (let i = 0; i < unitDataList.length; ++i) {
        if (unitDataList[i].order >= order) {
            order = unitDataList[i].order + 1;
        }
    }

    const unitId = Helper.generateUUID();

    //综合题也要可以复制
    let subunits = null;
    if(unitType.id === 'PSSO1'){
        let newVo = {...vo, unitType: unitType.id, data: JSON.stringify(vo.data), id: unitId}
        subunits = makeSubUnits(newVo);
    }

    unitDataList.splice(index, 0, {
        id: unitId,
        ownerType: ownerType,
        ownerId: ownerId,
        resourceId: Helper.generateUUID(),
        unitType: unitType.id,
        duration: unitType.duration,
        data: data,
        order: order,
        isNew: true,
        modified: g_modifySeq,
        changed: (changed ? true : false),
        skipValidate: (skipValidate ? true : false),
        //subunits: (unitType.id === 'PSSO1' ? [] : null),  //屏蔽这个判断，综合题也要可以复制
        subunits: subunits,
        addsub: false,
    });

    g_modifySeq += 1;

    if (cb) {
        cb(unitId);
    }
    return { ...state, unitDataList, editUnitId: unitId };
};

const showAddSubUnitReducer = (state, { unitId, show }) => {
    let unitDataList = _.clone(state.unitDataList);
    const [index, subIndex] = findUnitById(unitDataList, unitId);
    if (index < 0) {
        return { ...state };
    }

    const unit = _.cloneDeep(unitDataList[index]);
    unit.addsub = (show ? true : false);
    unitDataList[index] = unit;

    return { ...state, unitDataList };
};

const addSubUnitReducer = (state, { unitId, vo, cb }) => {
    const { unitType, ownerType, ownerId, data, changed, skipValidate } = vo;
    let unitDataList = _.clone(state.unitDataList);
    const [index, subIndex] = findUnitById(unitDataList, unitId);
    if (index < 0) {
        return { ...state };
    }

    const unit = _.cloneDeep(unitDataList[index]);
    const subUnitId = Helper.generateUUID();
    const order = unit.subunits.length + 1;
    unit.subunits.push({
        parentId: unitId,
        id: subUnitId,
        ownerType: ownerType,
        ownerId: ownerId,
        resourceId: Helper.generateUUID(),
        unitType: unitType.id,
        duration: unitType.duration,
        data: data,
        order: order,
        isNew: true,
        modified: g_modifySeq,
        changed: (changed ? true : false),
        skipValidate: (skipValidate ? true : false),
    });

    // add place holder for new sub unit data
    unit.data.practices.push(null);

    unit.addsub = false;
    unitDataList[index] = unit;

    g_modifySeq += 1;

    if (cb) {
        cb(subUnitId);
    }
    return { ...state, unitDataList, editUnitId: subUnitId };
};

function findUnitById(units, id) {
    for (let i = 0; i < units.length; ++i) {
        const unit = units[i];
        if (unit.id === id) {
            return [i, -1];
        }

        if (unit.subunits) {
            for (let j = 0; j < unit.subunits.length; ++j) {
                if (unit.subunits[j].id === id) {
                    return [i, j];
                }
            }
        }
    }
    return [-1, -1];
}

const moveUnitReducer = (state, { unitId, toIndex }) => {
    let unitDataList = _.clone(state.unitDataList);
    let [index, subIndex] = findUnitById(unitDataList, unitId);
    if (index >= 0) {
        const unit = unitDataList[index];
        unitDataList.splice(index, 1);
        unitDataList.splice(toIndex, 0, unit);
    }
    return { ...state, unitDataList };
};

const updateUnitReducer = (state, { unitId, formData }) => {
    let unitDataList = _.clone(state.unitDataList);
    let [index, subIndex] = findUnitById(unitDataList, unitId);
    if (subIndex >= 0) {
        const unit = unitDataList[index];
        const newUnit = _.cloneDeep(unit);
        const subunit = newUnit.subunits[subIndex];
        const { ownerType, ownerId, resourceId, id, unitType, data, ...more } = subunit;
        const newData = { ...more, id, unitType, ownerType, ownerId, resourceId, dataType: formData.dataType, data: { ...data, ...formData.data }, ...formData.commonFieldValues, commonFieldValues: formData.commonFieldValues, saved: true, modified: g_modifySeq, changed: true, skipValidate: false };

        newUnit.subunits[subIndex] = newData;

        g_modifySeq += 1;
        unitDataList[index] = newUnit;
    } else if (index >= 0) {
        const unit = unitDataList[index];
        const { ownerType, ownerId, resourceId, id, unitType, data, ...more } = unit;
        const newData = { ...more, id, unitType, ownerType, ownerId, resourceId, dataType: formData.dataType, data: { ...data, ...formData.data }, ...formData.commonFieldValues, commonFieldValues: formData.commonFieldValues, saved: true, modified: g_modifySeq, changed: true, skipValidate: false };

        g_modifySeq += 1;
        unitDataList[index] = newData;
    }
    return { ...state, unitDataList };
};

const changeUnitTypeReducer = (state, { vo }) => {
    let unitDataList = _.clone(state.unitDataList);
    let [index, subIndex] = findUnitById(unitDataList, vo.unitId);
    if (subIndex >= 0) {
        const unit = unitDataList[index];
        const newUnit = _.cloneDeep(unit);
        const subunit = newUnit.subunits[subIndex];
        const { ownerType, ownerId, resourceId, id, unitType, data, ...others } = subunit;
        const newData = { ...others, id, unitType: vo.unitType, ownerType, ownerId, resourceId, data: vo.data, modified: g_modifySeq, skipValidate: false };

        newUnit.subunits[subIndex] = newData;

        g_modifySeq += 1;
        unitDataList[index] = newUnit;
    } else if (index >= 0) {
        const unit = unitDataList[index];
        const { ownerType, ownerId, resourceId, id, unitType, data, ...others } = unit;
        const newData = { ...others, id, unitType: vo.unitType, ownerType, ownerId, resourceId, data: vo.data, modified: g_modifySeq, skipValidate: false };
        newData.subunits = makeSubUnits(newData);

        g_modifySeq += 1;
        unitDataList[index] = newData;
    }
    return { ...state, unitDataList };
};

const editUnitReducer = (state, { unitId }) => {
    return { ...state, editUnitId: unitId };
};

const cancelEditReducer = (state) => {
    return { ...state, editUnitId: null };
};

const reorderAsyncPostReducer = (state, { unitId, toIndex, order }) => {
    let unitDataList = _.clone(state.unitDataList);
    let [index, subIndex] = findUnitById(unitDataList, unitId);
    if (index >= 0) {
        let unit = _.clone(unitDataList[index]);
        unit.order = order;
        unitDataList.splice(index, 1);
        unitDataList.splice(toIndex, 0, unit);
    }
    return { ...state, unitDataList };
};

const saveUnitSuccessPostReducer = (state, { data, vo, modifySeq }) => {
    let unitDataList = _.clone(state.unitDataList);
    let [index, subIndex] = findUnitById(unitDataList, vo.localId);
    if (subIndex >= 0) {
        const newUnit = _.cloneDeep(unitDataList[index]);
        const subunit = newUnit.subunits[subIndex];
        if (subunit.modified !== modifySeq) {
            return { ...state };
        }

        const newData = {...subunit, isNew: false, modified: 0, skipValidate: false};
        newUnit.subunits[subIndex] = newData;
        newUnit.data.practices[subIndex] = {
            unitType: newData.unitType,
            data: JSON.stringify(newData.data),
        };

        unitDataList[index] = newUnit;
    } else if (index >= 0) {
        const oldUnit = unitDataList[index];
        const oldId = unitDataList[index].id;
        if (unitDataList[index].modified !== modifySeq) {
            if (!vo.id) {
                unitDataList[index] = {...oldUnit, id: oldId, remoteId: data.unit.id, isNew: false, skipValidate: false};
                return { ...state, sectionId: data.sectionId, unitDataList };
            }
            return { ...state };
        }
        const unit = data.unit;
        const unitData = JSON.parse(unit.data);
        unit.unitType = toLocalUnitType(unit.unitType, unitData);
        const newData = {...oldUnit, ...unit, id: oldId, remoteId: unit.id, data: unitData, isNew: false, modified: 0, skipValidate: false};
        unitDataList[index] = newData;
    }
    return { ...state, sectionId: data.sectionId, unitDataList };
};

const deleteUnitReducer = (state, { unitId }) => {
    let unitDataList = _.clone(state.unitDataList);
    let [index, subIndex] = findUnitById(unitDataList, unitId);
    let editUnitId = (unitId === state.editUnitId) ? null : state.editUnitId;
    if (subIndex >= 0) {
        const unit = _.cloneDeep(unitDataList[index]);
        unit.subunits.splice(subIndex, 1);
        unit.data.practices.splice(subIndex, 1);

        const newData = { ...unit, saved: true, modified: g_modifySeq, changed: true, skipValidate: false };

        g_modifySeq += 1;
        unitDataList[index] = newData;
    } else if (index >= 0) {
        unitDataList.splice(index, 1);
    }
    return { ...state, unitDataList, editUnitId };
};

const deleteAllUnitsReducer = (state, { unitId }) => {
    return { ...state, unitDataList: [], editUnitId: null, showErrors: null };
};

const showErrorUnitsReducer = (state, { units }) => {
    return { ...state, showErrors: units };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CHANGE_TITLE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.CHANGE_TITLE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.CHANGE_TITLE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_UNIT_SILENT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_UNIT_SILENT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_UNIT_SILENT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.DELETE_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.DELETE_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.DELETE_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REORDER_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REORDER_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REORDER_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.BATCH_ADD_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.BATCH_ADD_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.BATCH_ADD_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.BATCHADD_AND_CREATE_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.BATCHADD_AND_CREATE_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.BATCHADD_AND_CREATE_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SELECT_UNIT_TYPE]: selectUnitTypeReducer,
    [ActionTypes.ADD_UNIT]: addUnitReducer,
    [ActionTypes.SHOW_ADD_SUBUNIT]: showAddSubUnitReducer,
    [ActionTypes.ADD_SUBUNIT]: addSubUnitReducer,
    [ActionTypes.MOVE_UNIT]: moveUnitReducer,
    [ActionTypes.UPDATE_UNIT]: updateUnitReducer,
    [ActionTypes.EDIT_UNIT]: editUnitReducer,
    [ActionTypes.CANCEL_EDIT]: cancelEditReducer,
    [ActionTypes.CHANGE_UNIT_TYPE]: changeUnitTypeReducer,
    [ActionTypes.DELETE_UNIT]: deleteUnitReducer,
    [ActionTypes.DELETE_ALL_UNITS]: deleteAllUnitsReducer,
    [ActionTypes.SHOW_ERROR_UNITS]: showErrorUnitsReducer,
    [ActionTypes.RECREATE]: recreateReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
